import { __PUBLIC__ } from '@/App';
import React, { useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { Modal } from '../Bicester';

const BicesterPrompt = ({ when }: { when: boolean }) => {
  const history = useHistory();

  const [isShowModal, setIsShowModal] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const [action, setAction] = useState('');

  const handleConfirm = () => {
    if (action === 'PUSH') {
      history.push(nextLocation);
    } else if (action === 'POP') {
      history.goBack();
    } else if (action === 'REPLACE') {
      history.replace(nextLocation);
    }
    setIsShowModal(false);
  };

  return (
    <>
      <Prompt
        when={when}
        message={(location, action) => {
          if (
            !isShowModal &&
            !window.location?.pathname?.endsWith(`${__PUBLIC__}${location?.pathname}`)
          ) {
            setNextLocation(location);
            setAction(action);
            setIsShowModal(true);
          }
          return isShowModal;
        }}
      />
      <Modal
        show={isShowModal}
        content="信息还没保存，确定离开吗？"
        confirm="确定"
        cancel="取消"
        onConfirm={handleConfirm}
        onCancel={() => setIsShowModal(false)}
      />
    </>
  );
};

export default BicesterPrompt;
